import React from 'react';
import { motion, useInView } from 'framer-motion';

/**
 * StaggerContainer - Creates beautiful staggered animations for child elements
 * Perfect for lists, grids, and card layouts
 */
const StaggerContainer = ({ 
  children, 
  staggerDelay = 0.1,
  initialDelay = 0,
  className = '',
  once = true
}) => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { 
    once, 
    amount: 0.1,
    margin: "-50px"
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: staggerDelay,
        delayChildren: initialDelay,
      }
    }
  };

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={containerVariants}
      className={className}
    >
      {children}
    </motion.div>
  );
};

/**
 * StaggerItem - Individual item to be used within StaggerContainer
 */
export const StaggerItem = ({ children, className = '' }) => {
  const itemVariants = {
    hidden: { 
      opacity: 0, 
      y: 30,
      scale: 0.95
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: "spring",
        damping: 20,
        stiffness: 100
      }
    }
  };

  return (
    <motion.div
      variants={itemVariants}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default StaggerContainer;
